import { Component } from "react";

import { withTranslation } from "react-i18next";
import type { WithTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { GridColumn } from "simplydo/react/ui/grid";

import util from "utils/utils";

import type { FeedCardSharedProps, FeedSubmittedIdeaItem } from "../types";
import FeedCard from "./FeedCard";

type CardLeftProps = { idea: FeedSubmittedIdeaItem };

const CardLeft = ({ idea }: CardLeftProps) => (
  <GridColumn stretched verticalAlign="middle" style={{ maxHeight: "100%" }}>
    <div className="cover-and-text">
      <Link
        to={`/ideas/${idea._id}`}
        className="image-link"
        style={{
          width: 50,
          height: 50,
          borderRadius: 10,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          backgroundImage: `url(${util.mixinCssUrlFallback(util.ideaCoverImage(idea, "200x200"), util.ideaCoverImage(undefined))})`,
        }}
      />
      <div className="content-meta-container">
        <span className="content-meta">SUBMITTED</span>
        <span className="content-name">
          <Link to={`/ideas/${idea._id}`}>{idea.name}</Link>
        </span>
      </div>
    </div>
  </GridColumn>
);

type SubmittedIdeaCardProps = FeedCardSharedProps &
  WithTranslation & { idea: FeedSubmittedIdeaItem };

class SubmittedIdeaCard extends Component<SubmittedIdeaCardProps> {
  render() {
    const { idea, hideAction, t, feedType } = this.props;
    return (
      <FeedCard
        feedType={feedType}
        ownerType={idea.company ? "company" : "user"}
        company={idea.ownerCompany}
        user={idea.owner}
        action="activityFeed.idea.submitted"
        date={idea.submittedAt}
        toLink={`/ideas/${idea._id}`}
        type={t("generic.idea")}
        cardContent={<CardLeft idea={idea} />}
        hideAction={hideAction}
      />
    );
  }
}

export default withTranslation()(SubmittedIdeaCard);
